export const isNumber = (value: string) => /^\d+$/.test(value);
